module.exports = __webpack_public_path__ + "img/apidays-top-5-reasons.49b1df21.jpg";